import { JsonRestApiRequestConfig, makeJsonRestApiRequest } from '~src/httpClient/RestApiService';

import { IAuthFederationKey } from '../service/AuthFederationService';

export function postAuthFederationKeyRequestConfig(): JsonRestApiRequestConfig {
  return {
    restApiVersion: '3.30',
    httpMethod: 'POST',
    endpoint: 'auth-federation/admin/keys',
    serverWideRequest: false
  };
}

export function callPostAuthFederationKeyRequest(): Promise<IAuthFederationKey> {
  return makeJsonRestApiRequest<null, any>({
    config: postAuthFederationKeyRequestConfig(),
    request: null
  }).then((response) => {
    if (!response.authFederationKey) {
      throw new Error('createKey response missing the created key');
    }
    return response.authFederationKey as IAuthFederationKey;
  });
}
